import { Component, input, InputSignal } from '@angular/core';

import { ActionCardSection } from '@core/cms/landing.cms';
import { CmsBtn } from '@shared/ui/cms-btn/cms-btn';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/** Renders a `ComponentSectionActionCard`: a content panel with a list of call-to-action buttons. */
@Component({
    selector: 'cms-action-card',
    imports: [CmsBtn, TrustHtmlPipe],
    templateUrl: './action-card.html',
    styleUrl: './action-card.scss',
})
export class CmsActionCard {
    public readonly section: InputSignal<ActionCardSection> = input.required<ActionCardSection>();
}
